'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useTranslation } from 'react-i18next';

// UI lib components
import { Alert, Center, Text } from '@mantine/core';

// Types
import { NoDataProps } from './types';

// Assets
import { IconInfoCircle as IconInfo } from '@tabler/icons-react';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function NoData({ title, message, ...props }: NoDataProps) {
  /* ********************************** HOOKS ********************************* */

  // Localization
  const { t } = useTranslation('Common');

  /* ******************************** RENDERING ******************************* */
  return (
    <Center h="100%">
      <Alert
        title={title ?? t('placeholders.noData.title')}
        p="xl"
        icon={<IconInfo />}
        color="blackroomBlue"
        {...props}
      >
        <Text size="sm">{message ?? t('placeholders.noData.message')}</Text>
      </Alert>
    </Center>
  );
}

export default NoData;
